import {
  Box,
  Button,
  Grid,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import useDebounce from "../../../hooks/UseDebounce";
import {
  autoFocusOffWithOutBorder,
  drTableGreen,
} from "../../../style/PatinetFormStyle";
import {
  orangeButton,
  primaryBtnTeal,
  selectStyles,
} from "../../../style/PatientDetailsStyle";
import Select, { components } from "react-select";
import CreatableSelect from "react-select/creatable";
import { Search } from "@mui/icons-material";
import { getMedicalTest } from "../../../connections/getApi";
import { useQuery } from "@tanstack/react-query";
import AddIcon from "@mui/icons-material/Add";
import ArrowBackIosOutlinedIcon from "@mui/icons-material/ArrowBackIosOutlined";
import UseFetchSpecialInstructions from "../../../helper/UseFetchSpecialInstructions";
import UseFetchDiagnosisList from "../../../helper/UseFetchDiagnosisList";
import CloseIcon from "@mui/icons-material/Close";
import { xBtn } from "../../../style/LapPageStyle";
import UseFetchMedicineAdmin from "../../../helper/UseFetchMedicineAdmin";
import UseFetchDosageList from "../../../helper/UseFetchDosageList";
import UseFetchMedicineRemarks from "../../../helper/UseFetchMedicineRemarks";
import UseFetchFormType from "../../../helper/UseFetchFormType";
import UseFetchMedicineSaltList from "../../../helper/UseFetchMedicineSaltList";
import { showToast } from "../../../utils/toastUtil";
import { postTreatmentTemplates } from "../../../connections/postApi";
import { elGR } from "@mui/x-date-pickers/locales";
import { updateTreatments } from "../../../connections/putApi";

const UpdateTreatmentTemplates = ({
  refetch,
  onClose,
  templateData,
  setTemplateData,
  setIsEdit,
}) => {
  const [page, setPage] = useState(1);
  const [itemPerPage, setItemPerPage] = useState(10);
  const [errors, setErrors] = useState(true);
  const [medSaltInput, setMedSaltInput] = useState("");

  const [formState, setFormState] = useState({
    name: "",
    self_notes: "",
    diagnosis: [],
    special_instructions: [],
    medical_tests: [],
    treatment_medicines_attributes: [],
  });
  const [medicinesAttributes, setMedicines] = useState([
    { id: "", name: "", description: [], remark: [] },
  ]);
  const [isTyping, setIsTyping] = useState(false);

  console.log(medicinesAttributes, "medicinesAttributes");
  const { data: diagnosis, isLoading: diagnosisLoading } =
    UseFetchDiagnosisList(page, itemPerPage, "all");
  const [searchSpecialInst, setSearchSpecialInst] = useState("");
  const handleSplChange = (inputValue) => {
    setSearchSpecialInst(inputValue);
  };
  const debouncedSearchSpecialInst = useDebounce(searchSpecialInst, 600);
  const { data: specialInst, isLoading: splInstructionLoading } =
    UseFetchSpecialInstructions(
      page,
      itemPerPage,
      debouncedSearchSpecialInst,
      "all",
    );
  const [medicalInput, setMedicalInput] = useState("");
  const handleMedicalChange = (inputValue) => {
    setMedicalInput(inputValue);
  };
  const debouncedInputMedicineData = useDebounce(medicalInput, 600);
  const { data: getAllMedicalTestData, isFetching: medicalTestLoader } =
    useQuery({
      queryKey: ["getMedicalTest", "all"],
      queryFn: () => getMedicalTest(1, 10, null, debouncedInputMedicineData),
      enabled: !!debouncedInputMedicineData,
      refetchOnWindowFocus: false, // Don't refetch when window regains focus
      refetchOnReconnect: false, // Don't refetch when reconnecting
    });
  const allMedicalTest = getAllMedicalTestData?.payload?.medical_tests || [];
  const formattedMedicalTest = allMedicalTest?.map((el) => ({
    label: el.name,
    value: el.name,
  }));

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormState((prev) => ({
      ...prev,
      [name]: value,
    }));
    setErrors((prev) => ({ ...prev, [name]: undefined }));
  };

  const handleAddRow = () => {
    setMedicines([
      ...medicinesAttributes,
      { id: "", name: "", description: [], remark: [] },
    ]);
  };

  const handleRemoveRow = (e, index) => {
    const newMedicines = medicinesAttributes.filter((_, idx) => idx !== index);
    setMedicines(newMedicines);
  };

  // const handleChangeMedicine = (index, field, value, isNew) => {
  //     const newMedicines = [...medicinesAttributes];
  //     const updatedMedicine = { ...newMedicines[index], [field]: value };
  //     // Handle NEW medicine selection
  //     if (isNew) {
  //         updatedMedicine.isNew = true;
  //         updatedMedicine.name = value; // value is the name for new medicine
  //         delete updatedMedicine.medicine_id;
  //     }
  //     // Handle EXISTING medicine selection
  //     if (!isNew && field === "medicine_id") {
  //         updatedMedicine.isNew = false;
  //         updatedMedicine.medicine_id = value;
  //         updatedMedicine.name = null; // clear the name because it's existing
  //     }

  //     // If clearing the medicine_id, also clear the name
  //     if (field === "medicine_id" && !value) {
  //         updatedMedicine.isNew = false;
  //         updatedMedicine.medicine_id = "";
  //         updatedMedicine.name = null;
  //     }

  //     // Preserve isNew flag if provided, otherwise keep existing value
  //     // if (isNew !== undefined) {
  //     //   updatedMedicine.isNew = isNew;
  //     // }
  //     newMedicines[index] = updatedMedicine;
  //     setMedicines(newMedicines);
  // };
  const handleChangeMedicine = (index, field, value) => {
    const newMedicines = [...medicinesAttributes];
    const updatedMedicine = { ...newMedicines[index] };

    // Clear case
    if (field === "clear") {
      updatedMedicine.medicine_id = "";
      updatedMedicine.name = "";
      updatedMedicine.isNew = false;
    }

    // Medicine select/change case
    if (field === "medicine") {
      updatedMedicine.medicine_id = value.medicine_id;
      updatedMedicine.name = value.name;
      updatedMedicine.isNew = value.isNew;
    }

    // Other fields (description, remarks, etc.)
    if (!["medicine", "clear"].includes(field)) {
      updatedMedicine[field] = value;
    }

    newMedicines[index] = updatedMedicine;
    setMedicines(newMedicines);
  };

  const [medicineSearchInput, setMedicineSearchInput] = useState(null);

  const handleMedicineChange = (value) => {
    setIsTyping(true);
    setMedicineSearchInput(value);
  };

  const debouncedInputMedicine = useDebounce(medicineSearchInput, 600);

  const { data: getAllMedicineData, isFetching: medicineFetching } =
    UseFetchMedicineAdmin(page, itemPerPage, debouncedInputMedicine);
  const allMedicine = getAllMedicineData?.payload?.medicines || [];
  const formattedMedicineOptions = allMedicine?.map((el) => ({
    value: el?.id,
    label: el.name,
  }));

  const { data: getMedicineDescData, isLoading: medDescLoader } =
    UseFetchDosageList(page, itemPerPage, null, "all");
  const allMedicineDescription =
    getMedicineDescData?.payload?.medicine_descriptions || [];
  const formattedMedicineDescription = allMedicineDescription?.map((el) => ({
    value: el?.value,
    label: el.value,
  }));

  //medicine remarks options
  const { data: medicineRemarkData, isLoading: remarksLoader } =
    UseFetchMedicineRemarks(page, itemPerPage, null, "all");
  const allMedicineRemarks =
    medicineRemarkData?.payload?.medicine_remarks || [];
  const formattedMedicineRemarks = allMedicineRemarks?.map((el) => ({
    value: el?.value,
    label: el.value,
  }));

  const { data: getAllFormTypeData } = UseFetchFormType();
  const dataForm = getAllFormTypeData?.payload?.form_types || [];
  const formattedFormType = dataForm?.map((el) => ({
    value: el?.value,
    label: el?.label,
  }));

  const debouncedInputSalt = useDebounce(medSaltInput, 700);
  const { data: getMedSalt, isFetching: saltFetching } =
    UseFetchMedicineSaltList(page, itemPerPage, debouncedInputSalt);
  const data = getMedSalt?.payload?.medicine_salts || [];
  const formattedMedSalt = data.map((el) => ({
    value: el.name,
    label: el.name,
  }));

  const handleSearchMedSalt = (inputValue) => {
    setIsTyping(true);
    setMedSaltInput(inputValue);
  };

  function cleanPayload(obj) {
    if (Array.isArray(obj)) {
      return obj.map(cleanPayload).filter((item) => item != null);
    } else if (typeof obj === "object" && obj !== null) {
      return Object.fromEntries(
        Object.entries(obj)
          .map(([key, value]) => [key, cleanPayload(value)])
          .filter(([_, value]) => value != null && value !== ""),
      );
    }
    return obj;
  }

  useEffect(() => {
    if (!templateData) return;

    // Prefill simple fields

    // console.log(templateData, 'templateData')
    setFormState({
      name: templateData?.name || "",
      self_notes: templateData?.self_notes || "",
      diagnosis:
        templateData?.diagnosis?.map((d) => ({ value: d, label: d })) || [],
      special_instructions:
        templateData?.special_instructions?.map((si) => ({
          value: si,
          label: si,
        })) || [],
      medical_tests:
        templateData?.medical_tests?.map((mt) => ({
          value: mt,
          label: mt,
        })) || [],
    });

    // Prefill medicines (existing + new)
    const prefilledMedicines =
      templateData?.treatment_medicines?.map((m) => ({
        id: m.id,
        medicine_id: m?.medicine_id,
        name: m?.name || "",
        medicine_description: m.medicine_description || [],
        medicine_remark: m.medicine_remark || [],
      })) || [];

    setMedicines(prefilledMedicines);
  }, []);

  // console.log(medicinesAttributes, 'medicinesAttributes')

  const handleUpdateTreatment = async (e) => {
    e.preventDefault();
    const cleanedMedicinesAttributes = medicinesAttributes
      .map((item) => cleanPayload(item))
      .filter((item) => Object.keys(item).length > 0);
    // Split into two arrays
    const existingMedicines = [];
    const newMedicines = [];

    cleanedMedicinesAttributes.forEach((item) => {
      if (item?.medicine_id) {
        existingMedicines.push({
          id: item.id, // 👈 ADD THIS
          medicine_id: item.medicine_id,
          medicine_description: item?.medicine_description,
          medicine_remark: item?.medicine_remark,
          _destroy: "0", // 👈 ADD THIS
        });
      } else {
        newMedicines.push({
          name: item.name,
          form_type: item.form_type,
          salt_name: item.salt_name,
          medicine_description: item?.medicine_description,
          medicine_remark: item?.medicine_remark,
          _destroy: "0",
        });
      }
    });

    const originalMedicines = templateData?.treatment_medicines || [];

    // current ids (what user kept)
    const currentIds = cleanedMedicinesAttributes
      .filter((item) => item?.id)
      .map((item) => item.id);

    // deleted ids (present in source but not in current)
    const deleteMedicines = originalMedicines
      .filter((med) => !currentIds.includes(med.id))
      .map((med) => ({
        ...med,
        _destroy: "1",
      }));

    const payload = {
      treatment: {
        name: formState?.name,
        self_notes: formState?.self_notes,
        diagnosis: formState?.diagnosis?.map((option) => option.value) || [],
        special_instructions: formState?.special_instructions?.map(
          (el) => el?.value,
        ),
        medical_tests:
          formState?.medical_tests?.map((option) => option.value) || [],
        // old medicine
        treatment_medicines_attributes: [
          ...existingMedicines,
          ...deleteMedicines,
        ],
      },
      // new medicine
      ...(newMedicines.length > 0 && {
        new_medicines: newMedicines,
      }),
    };
    if (!formState?.name) {
      showToast("Please provide a name", "ERROR");
      return;
    }

    try {
      // console.log(payload, "payload");
      const data = await updateTreatments(payload, templateData?.id);
      if (data.status.status === "SUCCESS") {
        showToast("Treatment Added Successfully", "SUCCESS");
        setFormState({
          name: "",
          self_notes: "",
          diagnosis: [],
          special_instructions: [],
          medical_tests: [],
          treatment_medicines_attributes: [],
        });
        refetch();
        onClose();
      }
    } catch (error) {
      // toast.error(error.message);
      console.log(error);
    }
  };

  return (
    <Box sx={{ width: "100%", padding: 2 }}>
      <Box mb={2} ml={-1} sx={{ alignItems: "center", display: "flex" }}>
        <IconButton
          sx={{ marginBottom: "r0em" }}
          onClick={() => {
            onClose();
            setTemplateData({});
            setFormState({});
            setIsEdit(false);
            setMedicines([]);
          }}
        >
          <ArrowBackIosOutlinedIcon size="20px" sx={{ color: "#333333" }} />
        </IconButton>
        <Box>
          {" "}
          <Typography variant="heading2_14" color={"#333333"}>
            Back
          </Typography>
        </Box>
      </Box>

      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
        position="sticky"
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <Typography
            variant="title_medium"
            gutterBottom
            sx={{ fontSize: "20px" }}
          >
            Update Treatment Template
          </Typography>
        </Box>
      </Box>

      <Grid container spacing={1}>
        <Grid item sm={2.4}>
          <TextField
            value={formState?.name}
            fullWidth
            placeholder="Name"
            name="name"
            onChange={(e) => handleFormChange(e)}
            sx={{
              ...autoFocusOffWithOutBorder,
              "& .MuiOutlinedInput-root": {
                borderRadius: "8px",
                height: "50px",
                padding: "9px !important",
                "& input": {
                  padding: "8px",
                  fontSize: "14px",
                },
                backgroundColor: "neutral.white",
              },
            }}
            error={!!errors["name"]}
            helperText={errors["name"]}
          />
        </Grid>

        <Grid item sm={2.4}>
          <TextField
            value={formState?.self_notes}
            fullWidth
            placeholder="Self Notes "
            name="self_notes"
            onChange={(e) => handleFormChange(e)}
            sx={{
              ...autoFocusOffWithOutBorder,
              "& .MuiOutlinedInput-root": {
                borderRadius: "8px",
                height: "50px",
                padding: "9px !important",
                "& input": {
                  padding: "8px",
                  fontSize: "14px",
                },
                backgroundColor: "neutral.white",
              },
            }}
            error={!!errors["self_notes"]}
            helperText={errors["self_notes"]}
          />
        </Grid>

        <Grid item sm={2.4}>
          <CreatableSelect
            components={{
              DropdownIndicator: (props) => (
                <components.DropdownIndicator {...props}>
                  <Search style={{ color: "#999" }} />
                </components.DropdownIndicator>
              ),
              IndicatorSeparator: () => null,
            }}
            onInputChange={handleMedicalChange}
            isLoading={diagnosisLoading}
            options={diagnosis?.payload?.diagnoses.map((item) => ({
              value: item,
              label: item,
            }))}
            value={formState?.diagnosis?.map((item) => ({
              value: item.value,
              label: item.value,
            }))}
            onChange={(selectedOptions) => {
              setFormState((prev) => ({
                ...prev,
                diagnosis: selectedOptions,
              }));
            }}
            styles={{
              menu: (provided) => ({
                ...provided,
                zIndex: 9999, // Set your desired z-index here
                fontFamily: "lato",
              }),
              menuPortal: (base) => ({
                ...base,
                zIndex: 999999,
              }),
              control: (baseStyles, state) => ({
                ...baseStyles,
                borderColor: state.isFocused
                  ? "#2e37a4"
                  : "rgba(46, 55, 164, 0.1)",
                boxShadow: state.isFocused ? "0 0 0 1px #2e37a4" : "none",
                "&:hover": {
                  borderColor: "rgba(46, 55, 164, 0.1)",
                },
                fontFamily: "lato",
                borderRadius: "10px",
                fontSize: "14px",
                minHeight: "50px",
              }),
              dropdownIndicator: (base, state) => ({
                ...base,
                transform: state.selectProps.menuIsOpen
                  ? "rotate(-180deg)"
                  : "rotate(0)",
                transition: "250ms",
                width: "35px",
                height: "35px",
              }),
            }}
            isMulti
            isSearchable
            placeholder="Diagnosis"
            className="react-select"
            classNamePrefix="select"
          />
        </Grid>

        <Grid item sm={2.4}>
          <CreatableSelect
            components={{
              DropdownIndicator: (props) => (
                <components.DropdownIndicator {...props}>
                  <Search style={{ color: "#999" }} />
                </components.DropdownIndicator>
              ),
              IndicatorSeparator: () => null,
            }}
            onInputChange={handleSplChange}
            isLoading={splInstructionLoading}
            options={specialInst?.payload?.special_instructions?.map((el) => ({
              value: el.value,
              label: el.value,
            }))}
            value={formState?.special_instructions?.map((test) => ({
              value: test.value,
              label: test.label,
            }))}
            onChange={(selectedOptions) => {
              setFormState((prev) => ({
                ...prev,
                special_instructions: selectedOptions,
              }));
            }}
            styles={{
              menu: (provided) => ({
                ...provided,
                zIndex: 9999, // Set your desired z-index here
                fontFamily: "lato",
              }),
              menuPortal: (base) => ({
                ...base,
                zIndex: 999999,
              }),
              control: (baseStyles, state) => ({
                ...baseStyles,
                borderColor: state.isFocused
                  ? "#2e37a4"
                  : "rgba(46, 55, 164, 0.1)",
                boxShadow: state.isFocused ? "0 0 0 1px #2e37a4" : "none",
                "&:hover": {
                  borderColor: "rgba(46, 55, 164, 0.1)",
                },
                fontFamily: "lato",
                borderRadius: "10px",
                fontSize: "14px",
                minHeight: "50px",
              }),
              dropdownIndicator: (base, state) => ({
                ...base,
                transform: state.selectProps.menuIsOpen
                  ? "rotate(-180deg)"
                  : "rotate(0)",
                transition: "250ms",
                width: "35px",
                height: "35px",
              }),
            }}
            isMulti
            isSearchable
            placeholder="Special instructions"
            className="react-select"
            classNamePrefix="select"
          />
        </Grid>

        <Grid item sm={2.4}>
          <CreatableSelect
            components={{
              DropdownIndicator: (props) => (
                <components.DropdownIndicator {...props}>
                  <Search style={{ color: "#999" }} />
                </components.DropdownIndicator>
              ),
              IndicatorSeparator: () => null,
            }}
            onInputChange={handleMedicalChange}
            isLoading={medicalTestLoader}
            options={formattedMedicalTest}
            value={formState?.medical_tests?.map((test) => ({
              value: test.value,
              label: test.label,
            }))}
            onChange={(selectedOptions) => {
              setFormState((prev) => ({
                ...prev,
                medical_tests: selectedOptions,
              }));
            }}
            styles={{
              menu: (provided) => ({
                ...provided,
                zIndex: 9999, // Set your desired z-index here
                fontFamily: "lato",
              }),
              menuPortal: (base) => ({
                ...base,
                zIndex: 999999,
              }),
              control: (baseStyles, state) => ({
                ...baseStyles,
                borderColor: state.isFocused
                  ? "#2e37a4"
                  : "rgba(46, 55, 164, 0.1)",
                boxShadow: state.isFocused ? "0 0 0 1px #2e37a4" : "none",
                "&:hover": {
                  borderColor: "rgba(46, 55, 164, 0.1)",
                },
                fontFamily: "lato",
                borderRadius: "10px",
                fontSize: "14px",
                minHeight: "50px",
              }),
              dropdownIndicator: (base, state) => ({
                ...base,
                transform: state.selectProps.menuIsOpen
                  ? "rotate(-180deg)"
                  : "rotate(0)",
                transition: "250ms",
                width: "35px",
                height: "35px",
              }),
            }}
            isMulti
            isSearchable
            placeholder="Medical Test"
            className="react-select"
            classNamePrefix="select"
          />
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        {/* Heading */}
        <Grid item xs={12}>
          <Box sx={{ mb: 1, mt: 3 }}>
            <Typography
              variant="title_medium"
              gutterBottom
              sx={{ fontSize: "20px" }}
            >
              Update Treatment Medicine
            </Typography>
          </Box>
        </Grid>

        {/* Loop Rows */}
        {medicinesAttributes?.length > 0 &&
          medicinesAttributes?.map((el, index) => (
            <React.Fragment key={index}>
              {/* Serial + Medicine */}
              <Grid item xs={12} sm={6} md={4.5}>
                <Box display="flex" alignItems="center" width="100%">
                  <Typography sx={{ mr: 1 }}>{index + 1}</Typography>
                  <Box flex={1}>
                    <CreatableSelect
                      isLoading={medicineFetching}
                      options={formattedMedicineOptions}
                      // value={
                      //     el?.medicine_id
                      //         ? formattedMedicineOptions.find(
                      //             (m) => m?.value === el?.medicine_id
                      //         ) || null
                      //         : el?.isNew && el?.name
                      //             ? { label: el.name, value: el.name }
                      //             : null
                      // }
                      value={
                        el?.medicine_id
                          ? { value: el.medicine_id, label: el.name }
                          : el?.name
                            ? { value: el.name, label: el.name }
                            : null
                      }
                      onInputChange={handleMedicineChange}
                      onChange={(selectedOptions) => {
                        if (!selectedOptions) {
                          handleChangeMedicine(index, "clear");
                          return;
                        }

                        const isNew = selectedOptions.__isNew__ || false;

                        handleChangeMedicine(index, "medicine", {
                          medicine_id: isNew ? null : selectedOptions.value,
                          name: selectedOptions.label,
                          isNew,
                        });
                      }}
                      // name='medicine_id'
                      isSearchable
                      isClearable
                      placeholder="Choose medicine"
                      styles={selectStyles}
                    />
                  </Box>
                </Box>
              </Grid>

              {/* Medicine Description */}
              <Grid item xs={12} sm={6} md={4}>
                <CreatableSelect
                  isLoading={medDescLoader}
                  options={formattedMedicineDescription}
                  value={
                    el?.medicine_description?.map((desc) => ({
                      label: desc,
                      value: desc,
                    })) || []
                  }
                  onChange={(selectedOptions) => {
                    const selectedValues = (
                      Array.isArray(selectedOptions)
                        ? selectedOptions
                        : selectedOptions
                          ? [selectedOptions]
                          : []
                    ).map((option) => option.value);

                    handleChangeMedicine(
                      index,
                      "medicine_description",
                      selectedValues,
                    );
                  }}
                  isMulti
                  isSearchable
                  isClearable
                  placeholder="Choose medicine description"
                  styles={selectStyles}
                />
              </Grid>

              {/* Medicine Remarks */}
              <Grid item xs={12} sm={6} md={3}>
                {/* <Typography fontSize={14} fontWeight={600}>
                                    Medicine Remarks <span style={{ color: "red" }}>*</span>
                                </Typography> */}

                <CreatableSelect
                  isLoading={remarksLoader}
                  options={formattedMedicineRemarks}
                  value={el?.medicine_remark?.map((test) => ({
                    value: test,
                    label: test,
                  }))}
                  onChange={(selectedOptions) => {
                    const selectedValues = (
                      Array.isArray(selectedOptions)
                        ? selectedOptions
                        : selectedOptions
                          ? [selectedOptions]
                          : []
                    ).map((option) => option.value);

                    handleChangeMedicine(
                      index,
                      "medicine_remark",
                      selectedValues,
                    );
                  }}
                  isMulti
                  isSearchable
                  isClearable
                  placeholder="Choose medicine remarks"
                  styles={selectStyles}
                />
              </Grid>

              {/* Remove Row Button */}
              <Grid item xs={12} sm={6} md={0.4}>
                <IconButton
                  variant="contained"
                  color="error"
                  fullWidth
                  sx={{ height: "45px", borderRadius: "50%" }}
                  onClick={(e) => handleRemoveRow(e, index)}
                >
                  <CloseIcon />
                </IconButton>
              </Grid>

              {/* New Fields if el.isNew */}
              {el?.isNew && (
                <>
                  {/* Form Type */}
                  <Grid item xs={12} sm={6} md={4}>
                    {/* <Typography fontSize={14} fontWeight={600}>
                                            Form Type <span style={{ color: "red" }}>*</span>
                                        </Typography> */}

                    <Select
                      options={formattedFormType}
                      value={
                        el?.form_type
                          ? {
                              value: el.form_type,
                              label:
                                el.form_type.charAt(0).toUpperCase() +
                                el.form_type.slice(1),
                            }
                          : null
                      }
                      onChange={(opt) =>
                        handleChangeMedicine(index, "form_type", opt?.value)
                      }
                      styles={selectStyles}
                      placeholder="Select form type"
                    />
                  </Grid>

                  {/* Medicine Salt */}
                  <Grid item xs={12} sm={6} md={4}>
                    {/* <Typography fontSize={14} fontWeight={600}>
                                            Medicine Salt <span style={{ color: "red" }}>*</span>
                                        </Typography> */}

                    <CreatableSelect
                      isLoading={saltFetching}
                      options={formattedMedSalt}
                      onInputChange={handleSearchMedSalt}
                      value={
                        el?.salt_name
                          ? { value: el.salt_name, label: el.salt_name }
                          : null
                      }
                      onChange={(opt) =>
                        handleChangeMedicine(index, "salt_name", opt?.value)
                      }
                      isSearchable
                      isClearable
                      placeholder="Choose or create medicine salt"
                      styles={selectStyles}
                    />
                  </Grid>
                </>
              )}
            </React.Fragment>
          ))}

        {/* Add New Item Button */}
        <Grid item xs={12}>
          <Button
            variant="contained"
            color="primary"
            sx={{
              ...primaryBtnTeal,
            }}
            onClick={handleAddRow}
          >
            Add New Medicine
          </Button>
        </Grid>
      </Grid>

      <Box
        sx={{
          marginTop: 3,
          px: 1,
          width: "100%",
          display: "flex",
          justifyContent: "flex-end", // <-- This aligns the button to the right
        }}
      >
        <Button sx={{ ...primaryBtnTeal }} onClick={handleUpdateTreatment}>
          <Typography variant="heading2_14" color={"neutral.white"}>
            Update Template{" "}
          </Typography>
        </Button>
      </Box>
    </Box>
  );
};

export default UpdateTreatmentTemplates;
